import React, { useState, useEffect } from 'react';
import PopupModal from '../../../common/PopupModal';
import S from '../Home.module.scss';
import { Link, useNavigate } from 'react-router-dom';
import DonutChart from '../../../common/DonutChart';
import _ from 'lodash';
import { BookmarkType } from '../../../../types/RecruitmentTypes';
import { DateTimeUtils } from '../../../../utils/DateTimeUtils';
import Bookmark from '../../../common/Bookmark';

interface HomeMyResumeProps {
  score: number | null;
  avgScore: number | null;
  bookmarks: BookmarkType[];
  hasResume: boolean;
}

const HomeMyResume = (props: HomeMyResumeProps) => {
  const { score, avgScore, bookmarks, hasResume } = props;
  const [isOpenModal, setIsOpenModal] = useState<boolean>(false);
  const navigate = useNavigate();

  return (
    <>
      {/* 팝업 모달 시작 */}
      <PopupModal
        confirmFn={() => navigate('/resume')}
        isOpenModal={isOpenModal}
        setIsOpenModal={setIsOpenModal}
        needsCancelBtn={true}
        message="이력서 등록 후 점수 확인이 가능합니다. 이력서 등록 화면으로 이동하시겠습니까?"
      />
      {/* 팝업 모달 끝*/}
      <div className={S.info_area}>
        <div className={S.resume_point}>
          <h3 className="h3">이력서 점수</h3>
          <DonutChart
            myScore={score || 0}
            avgScore={avgScore || 0}
            hasScore={score !== null || score === 0}
            hasAvgScore={avgScore !== null || score === 0}
          />
          <div className={S.check_btn_area}>
            {hasResume ? (
              score == null ? (
                //  이력서 작성 후 점수 등록 대기중
                <div className={S.waiting_score_text}>
                  <p className="b2">
                    1차 서류 심사 진행중
                  </p>
                </div>
              ) : (
                //  이력서 작성 후 점수 등록 완료 뒤 버튼
                  <div className={S.waiting_score_text}>
                    <p className="b2">
                      AI 1차 서류 심사가 완료 되었습니다. <br />
                      현직 대기업 채용담당자가 2차 세부점수 심사중입니다.
                    </p>
                  </div>
                // <button
                //   type="button"
                //   className={S.check_point_btn}
                //   onClick={() => {
                //     navigate('/resume');
                //   }}
                // >
                //   <p className="button-m">이력서 수정하기</p>
                // </button>
              )
            ) : (
              //   이력서 작성 전
              <button
                type="button"
                className={S.check_point_btn}
                onClick={() => {
                  setIsOpenModal(true);
                }}
              >
                <p className="button-m">내 점수 확인하기</p>
              </button>
            )}
          </div>
        </div>
        <div className={S.recruit_insight}>
          <h4 className={`${S.recruit_insight_title} h4`}>
            채용 인사이트<span className={S.info_icon}></span>
          </h4>
          <div className={S.recruit_insight_list}>
            {Array(3)
              .fill(3)
              .map((_, index) => {
                if (bookmarks === undefined) {
                  return <BookmarkDetail bookmark={null} key={`bookmark_${index}`} />;
                } else {
                  return <BookmarkDetail bookmark={bookmarks[index]} key={`bookmark_${index}`} />;
                }
              })}
          </div>
        </div>
      </div>
    </>
  );
};

interface BookmarkDetailProps {
  bookmark: BookmarkType | null;
}

const BookmarkDetail = (props: BookmarkDetailProps) => {
  const { bookmark } = props;

  // 북마크 state
  const [isBookmarked, setIsBookmarked] = useState<boolean>(true);

  // 북마크 state update
  // useEffect(() => {
  //   setIsBookmarked(content.isBookmarked);
  // }, [content]);

  if (bookmark === undefined || bookmark === null) {
    return (
      <div className={S.recruit_insight_box}>
        <span className={S.plus_icon}></span>
      </div>
    );
  }



  return (
    <Link to={`/recruitment/${bookmark.jobId}`}>
      <div className={S.recruit_insight_fill_box}>
        <div className={S.recruit_info}>
          <p className={`${S.recruit_company} b4`}>{bookmark.company?.name || ''}</p>
          <div className="text-line-1-wrapper">
            <h6 className={`${S.recruit_post_title} b3`}>{bookmark.title || ''}</h6>
          </div>
        </div>
        <div className={S.flag_wrap}>
          <button type="button" className={S.flag_deadline}>
            <p className="button-s">{`${DateTimeUtils.calculateDaysRemaining(
              bookmark.endAt,
            )}일 남음`}</p>
          </button>
          <button type="button" className={S.flag_status}>
            <p className="button-s">{bookmark.closed ? '오늘마감' : '안정'}</p>
          </button>
          {/* 2.26 추가된 북마크 */}
          <Bookmark
            id={bookmark.jobId}
            isBookmarked={isBookmarked}
            setIsBookmarked={setIsBookmarked}
            isHomeInsight={true}
          />
        </div>
      </div>
    </Link>
  );
};

export default HomeMyResume;
